import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import { COURSE_EVENTS } from '@/content/values/events';

@Component({name: 'ed-create-c-material-sections'})
export default class EdCreateCMaterialSections extends Vue {

  @Prop() readonly materialSections: any;
  @Prop() readonly actualMaterial: any;
  @Prop() readonly level: number;
  @Prop() readonly viewed: any;

  /* Data */
  public opened: boolean = false;
  public selected: boolean = false;

  /* Computed */
  get state() {
    let paddingLeft = `edg-pad-left--${this.level == 1 ? this.level * 10 : this.level * 10}`;
    return { 
      opened: { 'ed-icon--is-opened': this.opened }, 
      container: { 
        'ed-section-title--is-selected': this.selected,
        [paddingLeft]: true
      }, 
      icon:  this.opened ? 'minus' : 'plus'
    }
  }

  get sectionName(): any {
    return  this.materialSections.sectionName;
  }

  get sublevel(): number {
    return this.level ? (this.level + 1) : 1;
  }

  get paddingLeft(): string {
    return `edg-pad-left--${(this.sublevel) * 10}`;
  } 

  get actualMaterialId(): number {
    if(this.actualMaterial) {
      return this.actualMaterial.relatedContentId;
    }
  }

  get viewedMaterialId() {
    //look in parent estructure which is the current selected material at the mini viewer
    let materialActiveAtViewer = this.viewed;
    let parentVueElement = this.$parent;
    while( !materialActiveAtViewer && parentVueElement ) {
      materialActiveAtViewer = (parentVueElement as any).currentSection;
      parentVueElement = parentVueElement.$parent;
    }
    
    if(materialActiveAtViewer) {
      return materialActiveAtViewer.id;
    }
  }

  /* Methods */
  public toggleOpened(): void {
   this.opened = !this.opened;
   this.selected = !this.selected;
  }

  public checkCurrentMaterial(material: any) : boolean{
    if(!this.actualMaterial) {
      return false;
    }
    return material.relatedContentId == this.actualMaterial.relatedContentId;
  } 

  public onRemove(): void {
    this.$emit('onRemove');
  }

  public onAdd(material: any) {
    this.$emit('onAdd', material);
  }

  public onView(material: any): void {
    this.$emit('onView', material);
  }

  public getFileExtension(mimeType: string) : string {
    let allowedExtensions: Map<string, string> = new Map();
    allowedExtensions
    .set('application/vnd.openxmlformats-officedocument.wordprocessingml.document', '.docx')
    .set('application/msword', '.doc')
    .set('application/pdf', '.pdf')
    .set('audio/mpeg', '.mp3')
    .set('audio/wav', '.wav')
    .set('audio/x-wav', '.wav')
    .set('video/mp4', '.mp4');

    return allowedExtensions.has(mimeType) ? allowedExtensions.get(mimeType) : '';
  }

  /* Hooks */
  created() {
    if(!this.materialSections.sectionName) {
      this.opened = true;
    } else {
      this.opened = this.materialSections.sectionId == this.actualMaterial ? this.actualMaterial.sectionParentId : false;
      this.selected = this.materialSections.sectionId == this.actualMaterial ? this.actualMaterial.sectionParentId : false;
    }
  } 
}